<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <div class="container-fluid">
    <!-- Loader -->
    @if (showJsonLoader) {
<div class="viewBatchLoader">
      <i class="fa fa-spinner fa-spin fa-2x gt-refresh"></i>
    </div>
}

    <!-- Content -->
    @if (!showJsonLoader) {
<div>
      <div class="JsonContainer">
        <span class="new new_block">SNS Message JSON</span>
        <div class="old_new_view" [innerHTML]="monitoringData"></div>
      </div>
    </div>
}
  </div>
</div>

<!-- Footer for modal -->
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
